import { translate } from '../../util/translate'

import HostInvoicesUser from '@/views/invoices/host/HostInvoicesUser'
import DisputeList from '@/views/dispute/DisputeList'

let hostRoute = [
  {
    path: '/host-invoices',
    name: 'host-invoices',
    component: HostInvoicesUser,
    meta: {
      login: true,
      title: translate['pages.title.invoices'],
      icon: 'mdi-text-box-outline',
      roles: ['ROLE_HOST'],
    }
  },
  {
    path: '/host-audits',
    name: 'host-audits',
    component: DisputeList,
    meta: {
      login: true,
      title: translate['pages.title.auditList'],
      icon: 'mdi-text-box-search-outline',
      roles: ['ROLE_HOST'],
    }
  }
]

export { hostRoute }
